import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
import Home from '@/views/FrontPage/Home.vue'
import Collections from '@/views/Collections.vue'
import CollectionDetail from '@/views/CollectionDetail.vue'
import NotFound from '@/views/NotFound.vue'
import ImportData from '@/views/ImportData.vue'
import ShopManage from '@/views/ShopManage/ShopManage.vue'
import overview from '@/views/ProductOverview/index.vue'
import ShoesPage from '@/views/ShoesList/ShoesPage.vue'
import ShoesListOne from '@/views/ShoesList/ShoesListOne.vue'
import HomePage from '@/views/Home/HomePage.vue'
import GoodsKindType from '@/views/ShoesList/ShoesType.vue'
import Cart from '@/views/ShoppingCart/index.vue'
import homePage from '@/views/Home/index.vue'
import ShoesDetail from '@/views/ShoesList/ShoeDetail.vue'
import ShoesColl from "@/views/CollectPage/index.vue"
import MyOrder from '@/views/OrderManage/MyOrder.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '德財家居'
    }
  },
  {
    path:  '/user/line/callback',
    name: 'LineCallback',
    component: () => import("../views/Login/components/LineCallback.vue"), 
  },
  {
    path:'/auth',
    name:'Auth',
    component: () => import("../views/Login/index.vue"),
    children: [
      {
        path:'',
        alias:'login',
        name:'Login',
        meta: { requiresAdmin: false},
        component: () => import('../views/Login/Loginpage.vue')
      },
      {
        path:'register',
        name:'Register',
        component: () => import("../views/Login/RegisterPage.vue")
      },
      {
        path:'forget',
        name:'Forget',
        component: () => import("../views/Login/ForgetPage.vue") 
      }
    ]
  },
  {
    path: '/home',
    name: 'MyHome',
    component: () => import("../views/Home/index.vue"),
    redirect: { name: 'HomePage' },
    children: [
      {
        path: '',
        name: 'HomePage',
        component: () => import("../views/Home/HomePage.vue"),
      },
      {
       path:'cart',
       name:'Cart',
       component: () => import("../views/ShoppingCart/index.vue"), 
      },
      {
        path:'order',
        name:'Order',
        component: () => import("../views/OrderManage/MyOrder.vue"), 
      },
      {
        path:'collect',
        name:'Collect',
        component: () => import("../views/CollectPage/index.vue"),
      },
      {
        path: 'shopmanages',
        name: 'ShopManage',
        component: () => import("../views/ShopManage/ShopManage.vue"),
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'frontPage',
        name: 'FrontPage',
        component: () => import('../views/pageManage/index.vue'), 
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'article',
        name: 'ArticleManage',
        component: () => import('../views/ArticleManage/ArticleManagement.vue'), 
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'article/edit/:id',
        name: 'ArticleEdit',
        component: () => import('../views/ArticleManage/components/ArticleEditPage.vue'),
        requiresAdmin: true,
        props: true,
        meta: { 
          mode: 'edit',
          requiresAdmin: true,
        } 
      },
      {
        path: 'article/add',
        name: 'ArticleCreate',
        component: () => import('../views/ArticleManage/components/ArticleEditPage.vue'),
        requiresAdmin: true,
        meta: { 
          mode: 'create',
          requiresAdmin: true, 
        }
      },
      {
        path: 'collections',
        name: 'CollectionManage',
        component: () => import('../views/Cooperate/index.vue'),
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'customize',
        name: 'Customize',
        component: () => import('../views/FontCustomize/index.vue'), 
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'discount',
        name: 'Discount',
        component: () => import('../views/GlobalDiscountManage/index.vue'), 
        meta:{
          requiresAdmin: true,
        }
      },
      {
        path: 'orderManage',
        name: 'OrderManage',
        component: () => import('../views/OrderManage/OrderManage.vue'), 
        meta:{
          requiresAdmin: true,
        }
      }
    ]
  },
  {
    path: '/article/view/:id',
    name: 'ArticleDetail',
    component: () => import('../views/ArticleManage/components/ArticleView.vue'), 
  },
  {
    path: '/shoes',
    name: 'ShoesList',
    children: [
      {
        path: '',
        name: 'ShoesPage',
        component: async () => import('../views/ShoesList/ShoesPage.vue'), 
      },
      {
        path: 'search',
        name: 'ShoesSearch',
        component: async () => import('../views/ShoesList/ShoesListOne.vue'),
      },
      {
        path: ':id',
        name: 'ShoeDetail',
        component: async () => import('../views/ShoesList/ShoeDetail.vue'),
        props: true,
      },
    ]
  },
  {
    path: '/cOrder',
    name: 'CheckOrder',
    component: async () => import('../views/OrderManage/ConfirmOrderPage.vue'),
  },
  {
    path: '/payment-not-available',
    name: 'PaymentNotAvailable',
    component: () => import('../views/OrderManage/PaymentNotAvailable.vue'),
    meta: {
      title: '支付功能暫未開放'
    }
  },
  {
    path: '/overview',
    name: 'Overview',
    component: async () => import('../views/ProductOverview/index.vue'), 
  },
  {
    path: '/types/:kindName',
    name: 'Types',
    component: async () => import('../views/ShoesList/ShoesType.vue'),
    props: true,
  },
  {
    path: '/collections',
    name: 'Collections',
    component: () => import('../views/ArticleManage/components/ArticleList.vue'),
  },
  {
    path: '/collections/:id',
    name: 'CollectionDetail',
    component: CollectionDetail,
    props: true,
  },
  {
    path: '/import',
    name: 'ImportData',
    component: ImportData,
    meta: {
      hidden: true,
      requiresAdmin: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '頁面未找到'
    }
  },
  {
   path: '/about',
   name: 'About',
   component: () => import('../views/About.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '德財家居'
  const displayedUserInfo = store.getters['auth/currentRole'];
  // 檢查頁面是否需要管理員權限
  if (to.meta.requiresAdmin) {
    if (displayedUserInfo != 'admin') {
      return next({ path: '/' });
    }
  }
  // 其他页面直接放行
  next()
})

export default router 